import Marquee from "react-fast-marquee";
import { MARQUEE } from "@/data/site";

export const EditorialMarquee = () => {
  return (
    <div data-testid="marquee" className="bg-[#0055FF] py-4 overflow-hidden border-y border-[#0055FF]">
      <Marquee speed={40} gradient={false} autoFill>
        {MARQUEE.map((word, i) => (
          <span key={i} className="flex items-center">
            <span className="font-mono-tech text-[#F5F1EA] text-sm md:text-base uppercase tracking-widest font-500 px-8">
              {word}
            </span>
            <span className="text-[#F5F1EA]/50 text-sm">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
